import _ from 'lodash'
import { Encrypted, Unencrypted, RecursiveEntity } from '@/types/crypto'
import { APIResponse } from '@/types/api/api'

export const isEncrypted = (obj: any): obj is Encrypted =>
    typeof obj.content === 'string'

export const isUnencrypted = (obj: any): obj is Unencrypted =>
    !isEncrypted(obj)

export const isRecursiveEntity = (obj: any): obj is RecursiveEntity<any> =>
    _.has(obj, 'fullRecursiveChildren')

export const isAPIResponse = (obj: any): obj is APIResponse =>
    _.has(obj, 'status')

export default {}
